import { render } from "./MyPhoto.vue?vue&type=template&id=7c602bdf"
import script from "./MyPhoto.vue?vue&type=script&lang=js"
export * from "./MyPhoto.vue?vue&type=script&lang=js"

import "./MyPhoto.vue?vue&type=style&index=0&id=7c602bdf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__